import React from 'react';
import './PrivacyPolicy.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy"> <Header />
     <br/><br/>
      <div className="container">
        <header className="privacy-header">
          <h1>Privacy Policy</h1>
        </header>
        
        <section className="privacy-section">
          <p>SellWise360 ("we," "our," or "us") respects your privacy and is committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our FMCG distribution SaaS solution, including our DMS web platform and MSP mobile application.</p>
          
          <p>By using SellWise360, you agree to the collection and use of information in accordance with this policy.</p>
        </section>
        
        <section className="privacy-section">
          <h2>1. Information We Collect</h2>
          
          <h3>Personal Information</h3>
          <ul>
            <li><strong>Account Information:</strong> Name, email address, phone number, company name, job title</li>
            <li><strong>Business Information:</strong> Company size, industry type, business address, tax information</li>
            <li><strong>Contact Information:</strong> For retailers and customers in your distribution network</li>
          </ul>
          
          <h3>Usage and Technical Data</h3>
          <ul>
            <li><strong>Device Information:</strong> Device type, operating system, browser type, IP address, mobile device ID</li>
            <li><strong>Location Data:</strong> For route optimization and delivery tracking (with explicit consent)</li>
            <li><strong>Usage Data:</strong> Feature usage, session duration, error logs, performance data</li>
            <li><strong>Business Data:</strong> Inventory levels, sales transactions, order history, customer information (as provided by you)</li>
          </ul>
        </section>
        
        <section className="privacy-section">
          <h2>2. How We Use Your Information</h2>
          <ul>
            <li>To provide, operate, and maintain our services</li>
            <li>To process transactions and manage your account</li>
            <li>To provide route optimization and delivery tracking</li>
            <li>To analyze usage patterns and improve our services</li>
            <li>To communicate with you about service updates, security alerts, and support messages</li>
            <li>To comply with legal obligations and prevent fraudulent activities</li>
          </ul>
        </section>
        
        <section className="privacy-section">
          <h2>3. Data Sharing and Disclosure</h2>
          
          <h3>We may share information with:</h3>
          <ul>
            <li><strong>Service Providers:</strong> Third-party vendors who assist in providing our services (hosting, analytics, payment processing)</li>
            <li><strong>Business Partners:</strong> Only when necessary to provide specific features you request</li>
            <li><strong>Legal Authorities:</strong> When required by law or to protect our rights and safety</li>
            <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets</li>
          </ul>
          
          <p>We do not sell your personal information to third parties.</p>
        </section>
        
        <section className="privacy-section">
          <h2>4. Data Security</h2>
          <p>We implement appropriate technical and organizational security measures to protect your personal data, including encryption, access controls, and regular security assessments. However, no method of transmission over the Internet or electronic storage is 100% secure.</p>
        </section>
        
        <section className="privacy-section">
          <h2>5. Data Retention</h2>
          <p>We retain personal data only for as long as necessary to fulfill the purposes outlined in this policy, unless a longer retention period is required by law. Business transaction data is retained according to standard accounting practices.</p>
        </section>
        
        <section className="privacy-section">
          <h2>6. Your Rights and Choices</h2>
          <p>Depending on your location, you may have certain rights regarding your personal data:</p>
          <ul>
            <li><strong>Access:</strong> Request access to your personal data</li>
            <li><strong>Correction:</strong> Request correction of inaccurate data</li>
            <li><strong>Deletion:</strong> Request deletion of your personal data (subject to legal requirements)</li>
            <li><strong>Objection:</strong> Object to processing of your data</li>
            <li><strong>Data Portability:</strong> Request transfer of your data to another service</li>
            <li><strong>Withdraw Consent:</strong> Withdraw previously given consent</li>
          </ul>
          <p>To exercise these rights, contact us at <a href="mailto:privacy@sellwise360.com">privacy@sellwise360.com</a>.</p>
        </section>
        
        <section className="privacy-section">
          <h2>7. Mobile Application Specific Information</h2>
          
          <h3>Android App (Google Play Requirements):</h3>
          <ul>
            <li>Our MSP mobile app may request location permissions for route optimization features</li>
            <li>We use Google Analytics for Firebase to understand app usage patterns</li>
            <li>Data collection is disclosed in Google Play Data Safety section</li>
            <li>You can manage app permissions through your device settings</li>
          </ul>
          
          <h3>App Store Privacy Details (Apple Requirements):</h3>
          <ul>
            <li><strong>Data Used to Track You:</strong> None</li>
            <li><strong>Data Linked to You:</strong> Contact info, usage data, location (for route optimization)</li>
            <li><strong>Data Not Linked to You:</strong> Diagnostics, performance data</li>
            <li>Data collection purposes are clearly disclosed in App Store Connect</li>
          </ul>
        </section>
        
        <section className="privacy-section">
          <h2>8. International Data Transfers</h2>
          <p>SellWise360 operates in Nigeria. If you are located outside Nigeria, please be aware that your information may be transferred to, stored, and processed in Nigeria where our servers are located and our central database is operated.</p>
        </section>
        
        <section className="privacy-section">
          <h2>9. Children's Privacy</h2>
          <p>Our services are not directed to individuals under 18. We do not knowingly collect personal information from children. If we become aware that a child has provided us with personal information, we will take steps to delete such information.</p>
        </section>
        
        <section className="privacy-section">
          <h2>10. Changes to This Policy</h2>
          <p>We may update this Privacy Policy periodically. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. You are advised to review this Privacy Policy periodically for any changes.</p>
        </section>
        
        <section className="privacy-section">
          <h2>11. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy or our data practices, please contact us:</p>
          <div className="contact-info">
            <p><strong>SellWise360</strong></p>
            <p>Barometergatan 35, 41841, Sweden<br/>
                6 Lateef Salami Street, Ajao Estate, Lagos, Nigeria</p>
            <p>Email: <a href="mailto:hello@sellwise360.com">hello@sellwise360.com</a></p>
                <p>+46-769702095<br/>+234-8133694347</p>
          </div>
        </section>
      </div> <Footer />
    </div>
  );
};

export default PrivacyPolicy;